import styled from 'styled-components';
import { theme } from '../../../styled/layout/theme';
import { size } from '../../../styled/layout/helpers';

export const SvgButton = styled.div`
  cursor: pointer;
  & .passive {
    display: block;
  }
  & .active,
  & .hover {
    display: none;
  }
  &.active .passive {
    display: none;
  }
  &.active .active {
    display: block;
  }
  &:hover .passive {
    display: none;
  }
  &:hover .hover {
    display: block;
  }
  &.active:hover .hover {
    display: none;
  }
`;

export const ImageWrapper = styled.div`
  display: flex;
  gap: ${size(1)};
  ${theme.screens.LtSm} {
    gap: ${size(1)};
  }
`;
